import axios from "axios";
import { useState } from "react";
import { Text, View } from "react-native";
import RenderHTML from "react-native-render-html";
import {APIadminsURL} from "@env";

function TosDumper() {
  const [source, setSource] = useState("");
  axios.get(`${APIadminsURL}/api/TermsOfUse`).then((res) => {
    setSource(res.data.agreement); // malgré mafamech 3leech
  });
  return (
    <View style={{ width: "90%", margin: 20, alignSelf: "center" }}>
      <View style={{ width: "100%", alignItems: "center", justifyContent: "center" }}>
        <Text style={{ fontFamily: "Roboto_700Bold", fontSize: 24 }}>Terms Of Service</Text>
      </View>
      <RenderHTML source={{ html: `${source}` }} />
    </View>
  );
}

export default TosDumper;
